import baobaoLogo from "@/assets/baobao-logo.png";

interface BrandLogoProps {
  compact?: boolean;
}

export default function BrandLogo({ compact = false }: BrandLogoProps) {
  return (
    <div className="flex items-center justify-center text-center">
      <img
        src={baobaoLogo}
        alt="BaoBao ロゴ"
        className={compact ? "w-[220px] max-w-[75vw] h-auto" : "w-[320px] max-w-[85vw] h-auto"}
      />
    </div>
  );
}
